import { useEffect, useState } from "react"
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../../toastify/config";
import apiSafibc from "../../../axios/axios";
import { Autocomplete, Box, FormControl, Modal, TextField } from "@mui/material";
import { useLoginStore } from '../../../store/zustend';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import PaidIcon from '@mui/icons-material/Paid';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '5px',
    width: '75%'
};

const Pagares = () => {

    const { loginStore } = useLoginStore()

    const [pagares, setPagares] = useState([])
    const [clientes, setClientes] = useState([])
    const [modalPagos, setModalPagos] = useState(false)
    const [pagarePagos, setPagarePagos] = useState(null)

    const obtenerClientes = () => {

        const obteniendo = async () => {
            try {

                const obtener = await apiSafibc('/pagares/clientes', {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setClientes(obtener.data)

            } catch (error) {
                console.log(error)
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener clientes, favor de volver a intentar!'
                    }
                }

                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }
        }




        obteniendo()

    }

    useEffect(() => {
        obtenerClientes()
    }, [])


    const handleChange = (e, id) => {
        e.preventDefault()
        consultarPagares(id)
    }

    const consultarPagares = (id) => {

        const consultar = async () => {
            try {

                const obtener = await apiSafibc(`/pagares/obtener/${id}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setPagares(obtener.data)

            } catch (error) {
                console.log(error)
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener pagares, favor de volver a intentar!'
                    }
                }

                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }
        }

        consultar()

    }

    const mirarImgPagare = () => {

    }

    const dineroFormatter = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN' // Puedes cambiar esto según la moneda que desees
    });

    const formatFecha = (value) => {

        const fecha = new Date(value + ' 08:00:00')
        const meses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']

        return `${fecha.getDate()} DE ${meses[fecha.getMonth()]} DE ${fecha.getFullYear()}`

    }

    const obtenerPagosPagare = (e, id) => {


        const obtenerPagos = async () => {

            try {

                const pagos = await apiSafibc(`/pagares/pagare/obtener-pagos/${id}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })
                console.log(pagos)
                setPagarePagos(pagos.data)

                setModalPagos(true)

            } catch (error) {
                console.log(error)
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener pagos de pagare, favor de volver a intentar!'
                    }
                }
                setModalPagos(false)
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }

        }

        obtenerPagos()

    }


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="card shadow">
                        <div className="card-body">
                            <div className="row">
                                <div className='col-md-6 mb-5'>
                                    <FormControl variant="standard" sx={{ minWidth: '100%' }}>

                                        <Autocomplete
                                            disablePortal
                                            options={clientes.map((cliente) => ({ id: cliente.id_cliente, label: `${cliente.nombre} ${cliente.paterno} ${cliente.materno}` }))}
                                            onChange={(event, cliente) => {
                                                if (!cliente) return
                                                handleChange(event, cliente.id)
                                            }}
                                            renderInput={(params) => <TextField {...params} label="Cliente" variant='standard' />}
                                        />


                                    </FormControl>
                                </div>

                                <div className='table-responsive'>

                                    <table className="table">
                                        <thead className='text-center'>
                                            <tr>
                                                <th>Folio Pagare</th>
                                                <th>Imagen Pagare</th>
                                                <th>Cliente</th>
                                                <th>Tipo Pagare</th>
                                                <th>Cantidad Prestada</th>
                                                <th>Meses</th>
                                                <th>Fecha Pagare</th>
                                                <th>Fecha Primer Pago</th>
                                                <th>Interes</th>
                                                <th>Estatus Pagare</th>
                                                <th>Registrado</th>
                                                <th>Pagos</th>
                                            </tr>
                                        </thead>
                                        <tbody className='text-center'>
                                            {pagares && pagares.map((pagare, i) => (
                                                <tr className='animation' key={i}>
                                                    <td>{pagare.folio_pagare}</td>
                                                    <td>
                                                        <ImageSearchIcon className="pointer" onClick={mirarImgPagare} />
                                                    </td>
                                                    <td>{pagare.nombre} {pagare.paterno} {pagare.materno}</td>
                                                    <td>{pagare.tipo_prestamo}</td>
                                                    <td>{dineroFormatter.format(pagare.cantidad_prestar)}</td>
                                                    <td>{pagare.cantidad_meses}</td>
                                                    <td>{formatFecha(pagare.fecha_prestamo)}</td>
                                                    <td>{formatFecha(pagare.fecha_primer_pago)}</td>
                                                    <td>{pagare.interes}</td>
                                                    <td>{pagare.estatus_pagare}</td>
                                                    <td>{formatFecha(pagare.fecha_primer_pago)}</td>
                                                    <td>
                                                        <PaidIcon className="pointer" onClick={(e) => obtenerPagosPagare(e, pagare.id_prestamo_pagare)} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                open={modalPagos}
                onClose={() => setModalPagos(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className='nav-header2 pt-4'></div>
                    <div className='card'>
                        <div className='card-header text-center'>
                            <h3>Pagos de Pagare</h3>
                        </div>
                        <div className='card-body'>
                            <div className='table-responsive'>

                                <table className="table">
                                    <thead className='text-center'>
                                        <tr>
                                            <th>Numero Pago</th>
                                            <th>Fecha Pago</th>
                                            <th>Capital</th>
                                            <th>Interes</th>
                                            <th>Monto Total</th>
                                            <th>Estado</th>
                                            <th>Fecha Pagado</th>
                                            <th>Abonar</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-center'>
                                        {pagarePagos && pagarePagos.map((pago, i) => (
                                            <tr className='animation' key={pago.id_pago_pagare}>
                                                <td>{pago.numero_pago}</td>
                                                <td>{formatFecha(pago.fecha_pago)}</td>
                                                <td>{dineroFormatter.format(pago.capital)}</td>
                                                <td>{dineroFormatter.format(pago.interes)}</td>
                                                <td>{dineroFormatter.format(pago.monto_total)}</td>
                                                <td className={pago.estado === '0' ? 'text-danger' : 'text-success'}>
                                                    {pago.estado === '0' ? 'NO PAGADO' : 'PAGADO'}
                                                </td>
                                                <td>{pago.fecha_pagado ? formatFecha(pago.fecha_pagado) : 'N/A'}</td>
                                                <td></td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>

                        </div>
                    </div>
                </Box>
            </Modal>

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </div>
    )

}

export default Pagares